import { css } from "styled-components";

export const v = {
    sidebarWidth: `300px`,
    smSpacing: `8px`,
    mdSpacing: `16px`,
    lgSpacing: `24px`,
    xlSpacing: `32px`,
    xxlSpacing: `48px`,
    borderRadius: `6px`,
    fontSizeMain: `14px`,
    fontSizeSecondary: `12px`,
    fontSizeParagraph: `15px`,
    fontWeight: `400`,
    fontWeightBold: `600`,
    fontWeightLight: `300`,
    fontWeightMedium: `500`,
    fontWeightSemiBold: `700`,
    fontWeightExtraBold: `800`,
};

export const btnReset = css`
    font-family: inherit;
    outline: none;
    border: none;
    background: none;
    letter-spacing: inherit;
    color: inherit;
    font-size: inherit;
    text-align: inherit;
    padding: 0;
`